export default [
	// ADMINISTRAÇÃO GERAL
	{
		modulo: 8,
		privilegio: 23,
		routerName: 'usuario',
		routerPath: '/usuario',
		componentName: 'Usuario',
		componentPath: 'modules/layout/usuario/usuario/main'
	},
	{
		modulo: 8,
		privilegio: 40,
		routerName: 'afastamento',
		routerPath: '/afastamento',
		componentName: 'Afastamento',
		componentPath: 'modules/layout/usuario/afastamento/alagoas/main'
	},
	{
		modulo: 8,
		privilegio: 23,
		routerName: 'perfil',
		routerPath: '/perfil',
		componentName: 'Perfil',
		componentPath: 'modules/layout/usuario/perfil/main'
	},
	{
		modulo: 0,
		privilegio: 0,
		routerName: 'novo-usuario',
		routerPath: '/novo-usuario',
		componentName: 'NovoUsuario',
		componentPath: 'modules/layout/usuario/novo-usuario/main'
	},
	{
		modulo: 0,
		privilegio: 0,
		routerName: 'usuario-termo',
		routerPath: '/usuario-termo',
		componentName: 'UsuarioTermo',
		componentPath: 'modules/layout/usuario/termo-de-uso/main'
	}
]
